/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var AdditionalActions;
(function (AdditionalActions) {
    AdditionalActions["BRAND_VOICE_GENERATION"] = "BRAND_VOICE_GENERATION";
    AdditionalActions["BRAND_VOICE_USE"] = "BRAND_VOICE_USE";
})(AdditionalActions || (AdditionalActions = {}));
